import { ReflectionVideosPage } from '@edwin-group/cj-graphql';
import { create } from 'zustand';

export interface Filters {
  keyStages?: string[];
}

interface ReflectionVideosState {
  filters: Filters;
  keysStages: { documentId: string; keyStage: string }[];
  page: { page: ReflectionVideosPage | null };
}

export const useReflectionVideosStore = create<ReflectionVideosState>(() => ({
  filters: {
    keyStages: [],
  },
  keysStages: [],
  page: { page: null },
}));
